import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import { FAQS } from "@/lib/constants";
import { useContent } from "@/lib/content";
import { useReveal } from "@/hooks/use-reveal";

export default function FaqSection() {
  const r = useReveal();
  const content = useContent();
  const faqs = (content?.faqs && content.faqs.length > 0) ? content.faqs : FAQS;
  return (
    <section className="py-20 sm:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={r.ref} className={r.className}>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-xl bg-[#0057B8]/10 text-[#0057B8] grid place-items-center">
              <HelpCircle className="w-5 h-5" />
            </div>
            <span className="text-sm font-semibold uppercase tracking-widest text-[#0E7490]">FAQ</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-[#111827] leading-tight">
            Frequently asked questions
          </h2>
          <p className="mt-3 text-[#6B7280] max-w-2xl">
            Answers to common questions about FASTag issuance, activation, recharge and delivery.
          </p>

          <Accordion type="single" collapsible className="mt-8 space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl px-5 data-[state=open]:bg-white data-[state=open]:shadow-md transition-shadow" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display font-semibold text-[#111827] text-base sm:text-lg hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#6B7280] text-base leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
